import { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'redux/reducers/type';
import { Storage } from 'commons/constants/KeyFlowConstants';
import StorageVO from 'commons/vo/StorageVO';
import CategoryVO from 'commons/vo/CategoryVO';

export default function useStorage() {
  const { isInit, isLoading, storageList } = useSelector((state: RootState) => state.storage);
  const { categoryList } = useSelector((state: RootState) => state.category);

  const mainStorage = useMemo(() => {
    const result = storageList.filter((storage: StorageVO) => storage.name === Storage.MAIN);
    return result || null;
  }, [storageList]);

  const getStorage = (categoryId: number) => {
    const category = categoryList.filter(({ id }: CategoryVO) => id === categoryId)[0];
    // console.debug({ category });
    const storage = storageList.filter(({ id }: StorageVO) => id === category?.storageId)[0];
    // console.debug({ storage });

    return storage;
  };

  return useMemo(
    () => ({
      isInit,
      isLoading,
      storageList,
      mainStorage,
      getStorage,
    }),
    [isInit, isLoading, storageList, mainStorage, getStorage],
  );
}
